import {z} from 'zod'
import {useURLParsedParams} from './useURLParsedParams'
import {useParsedSearchParams} from './useParsedSearchParams'
import {UserDetailsUrlParams} from '@/types'
import {useLayoutEffect, useState} from 'react'

const VerifyEmailSearchParams = z.object({token: z.string().trim()})
type VerifyEmailSearchParams = z.infer<typeof VerifyEmailSearchParams>

export const useEmailVerificationParams = () => {
    const [userId, setUserId] = useState<null | string>(null)
    const [token, setToken] = useState<null | string>(null)

    const urlParams = useURLParsedParams(UserDetailsUrlParams)
    const {searchParams} = useParsedSearchParams(VerifyEmailSearchParams)

    useLayoutEffect(() => {
        if (urlParams.success && urlParams.data?.id && searchParams.token) {
            setUserId(urlParams.data.id)
            setToken(searchParams.token)
        }
    }, [urlParams, searchParams.token])

    return {userId, token}
}
